import React, { useEffect, useRef, useContext } from 'react';
import './Voucher.css';
import PropTypes from 'prop-types';
import InfoIcon from '../../assets/InfoIcon.jsx';
import VodaPayClubIcon from '../../assets/VodaPayClubIcon.jsx';
import { SubscriptionDetailsContext } from '../../services/context/SubscriptionDetailsContext.js';

const VoucherHeader = ({ iconUrl, title, addedValue, isClubVoucher }) => {
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const isSubscribed = subscriptionDetails?.isSubscribed;
  const applyCss = !isSubscribed && isClubVoucher;
  const logoRef = useRef(null);
  useEffect(() => {
    logoRef.current?.style.setProperty('--image-url', `url(${iconUrl})`);
  }, [logoRef.current]);
  return (
    <header className='container'>
      {
        iconUrl
        && <div
          className='logo'
          ref={ logoRef }
        />
      }
      <section className={ applyCss ? 'info v-container v-disable' : 'info v-container' }>
        <h3>{title}</h3>
        <div className='added-value container-v'>
          <p>{addedValue}</p>
          {
            isClubVoucher
            && <VodaPayClubIcon />
          }
          {
            !iconUrl
            && <InfoIcon />
          }
        </div>
      </section>
    </header>
  );
};

VoucherHeader.propTypes = {
  iconUrl: PropTypes.string,
  title: PropTypes.element,
  addedValue: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]),
  isClubVoucher: PropTypes.bool,
};

/**
 * @param {object} props - The props for the component
 * @param {string} props.iconUrl - The URL for the logo
 * @param {JSX.Element} props.title - The Title element
 * @param {JSX.Element | string} props.addedValue - Element for added value
 * @param {JSX.Element} props.actionItem - Action item element
 * @param {Function} props.onClick - Function for clicking on component
 * @param {JSX.Element} props.isClubVoucher - Prop to check ClubVoucher category
 * @returns {JSX.Element} Voucher Component
 */
export default function Voucher({ iconUrl, title, addedValue, actionItem, onClick, isClubVoucher }) {
  const empty = (iconUrl ?? title ?? addedValue ?? actionItem ?? onClick) === undefined;
  return (
    <div className={ `voucher container-v${empty ? ' empty skeleton-loader' : ''}` }>
      {
        onClick ? <button
          onClick={ onClick }
          className='on-click'
        >
          <VoucherHeader
            iconUrl={ iconUrl }
            title={ title }
            addedValue={ addedValue }
            isClubVoucher={ isClubVoucher }
          />
        </button>
          : <div className='on-click'>
            <VoucherHeader
              iconUrl={ iconUrl }
              title={ title }
              addedValue={ addedValue }
              isClubVoucher={ isClubVoucher }
            />
          </div>
      }
      {
        actionItem
          && <div className='action-item'>{actionItem}</div>
      }
      {
        empty
          && <div className='action-item'>
            <div />
          </div>
      }
    </div>
  );
}

Voucher.propTypes = {
  onClick: PropTypes.func,
  iconUrl: PropTypes.string,
  title: PropTypes.element,
  addedValue: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]),
  actionItem: PropTypes.element,
  isClubVoucher: PropTypes.bool,
};
